import { FC, ReactElement, ReactNode } from 'react';
import { css } from '@emotion/react';
import { Button, Heading, Text, THeadingSize } from '@livechat/design-system-react-components';

import { CustomLink } from 'components/link/Link';
import { Layout } from 'components/layout/Layout';
import ChatWidget from 'modules/ChatWidget';

import * as styles from './styles';

const errorMessageButtonStyles = css`
  min-width: 120px;
`;

interface Props {
  imgSrc?: string;
  titleCaption: string;
  titleCaptionSize?: THeadingSize;
  titleContent: string | ReactElement;
  buttonText?: string | ReactElement;
  contactSupportButton?: boolean;
  link?: string;
  children?: ReactNode | null;
  onClick?: () => void;
  disabled?: boolean;
  isMissingAccess?: boolean;
  isUnknown?: boolean;
  backToLogin?: boolean;
  loading?: boolean;
}

export const ErrorMessageForm: FC<Props> = ({
  imgSrc = '',
  titleCaption,
  titleCaptionSize,
  titleContent,
  buttonText = '',
  contactSupportButton = false,
  link = '',
  children = null,
  onClick = undefined,
  disabled = false,
  isMissingAccess = false,
  isUnknown = false,
  backToLogin = false,
  loading,
}) => (
  <Layout backToLogin={backToLogin}>
    <div css={styles.container(isUnknown)}>
      <div>
        {imgSrc ? (
          <div css={styles.textContainer(isMissingAccess)}>
            <img css={styles.img} src={imgSrc} alt="" />
            <Heading size={titleCaptionSize || 'lg'}>{titleCaption}</Heading>
            <Text css={styles.text} data-testid="error-title-content">
              {titleContent}
            </Text>
          </div>
        ) : (
          <div css={styles.textContainer(isMissingAccess)}>
            <Heading size={titleCaptionSize || 'lg'}>{titleCaption}</Heading>
            <Text css={styles.text} data-testid="error-title-content">
              {titleContent}
            </Text>
          </div>
        )}
      </div>

      {(buttonText || contactSupportButton) && (
        <div css={styles.buttonContainer}>
          {contactSupportButton ? (
            <Button kind="primary" size="large" onClick={ChatWidget.handleContactSupport}>
              Get help
            </Button>
          ) : (
            <CustomLink to={link}>
              <Button
                onClick={onClick}
                disabled={disabled}
                kind="primary"
                size="large"
                css={errorMessageButtonStyles}
                loading={loading}
              >
                {buttonText}
              </Button>
            </CustomLink>
          )}
        </div>
      )}
      <div css={styles.childrenContainer}>{children}</div>
    </div>
  </Layout>
);
